import React from 'react';
import { Reveal } from './Reveal';
import { TestimonialCard } from './TestimonialCard';
import { reviews } from '../data/testimonials';
export function Reviews() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-208" data-mp="2mboy9x5jv8mb">
      <div className="mx-auto max-w-6xl" data-id="element-209" data-mp="2ma462e6pk1rm">
        <Reveal className="text-center" data-id="element-210" data-mp="2raidpv4ed9p4">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-211" data-mp="2rbl4m31pzc51">
            ⭐ Altre esperienze <span className="text-sage" data-id="element-212" data-mp="2w8toq96fhq8x">con il sistema</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-213" data-mp="30b83oi6z85ux">4.9/5 · Centinaia di persone hanno già iniziato il percorso.</p>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-214" data-mp="35380w2vnwknt">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.05} className="h-full" data-id="element-215" data-mp="3a087cewfbpfg" data-mpi={index}>
              <TestimonialCard item={review} className="p-7" data-id="element-216" data-mp="3f15oco5p6dfd" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}